/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/SpiderLogic/IDailySpiderAuthority',[
        'SolitaireShared/SpiderLogic/SpiderAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/MoveState'
    ], 
    function (SpiderAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

        var IDailySpiderAuthority = function () {
            this.initIDailySpiderAuthority();
        };

        IDailySpiderAuthority.TAG_MOVEPERFORMED = 0x40000000;

        IDailySpiderAuthority.constructor = IDailySpiderAuthority;
        IDailySpiderAuthority.prototype = Object.create(SpiderAuthority.prototype);
        IDailyAuthority.call(IDailySpiderAuthority.prototype);

        IDailySpiderAuthority.prototype.initIDailySpiderAuthority = function () {
            SpiderAuthority.call(this);

            this.MovesAllowed = 0;

            this._startingTime = 0;

            this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;

            this.DeckSeeds = [];

            this.IsChallenge = true;

            this.TotalMoves = 0;
        };

        IDailySpiderAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer) {
            return 0;
        };

        Object.defineProperty(IDailySpiderAuthority.prototype, "TimerEnabled", {
            get: function () {
                return this._startingTime != 0;
            }
        });

        Object.defineProperty(IDailySpiderAuthority.prototype, "StartingTime", {
            get: function () {
                return this._startingTime;
            },
            set: function (value) {
                this._startingTime = value;
                this.CardSupply.IsTimerCountdown = this._startingTime != 0;
            }
        });

        IDailySpiderAuthority.prototype.GetStartingTime = function () {
            return this._startingTime;
        };

        IDailySpiderAuthority.prototype.GetScoreForAction = function (action) {
            for (var i = 0; i < action.Ops.length; i++) {
                var op = action.Ops[i];
                if (this.MovesAllowed > 0 && action.GetActionUndoCount() == 0 && op.Opcode != CardOp.Op.Noop && op.Opcode != CardOp.Op.Deal) {
                    action.Tag = (action.Tag | IDailySpiderAuthority.TAG_MOVEPERFORMED) >>> 0;
                }
            }

            return SpiderAuthority.prototype.GetScoreForAction.call(this, action);
        };

        IDailySpiderAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
            if (this.MovesAllowed > 0)
                this.TotalMoves += (undo ? -1 : 1);

            SpiderAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
        };
  

        IDailySpiderAuthority.prototype.IsGameWon = function () {
            if (this.MovesAllowed > 0)
                return (SpiderAuthority.prototype.IsGameWon.call(this) && this.TotalMoves <= this.MovesAllowed + 1);
            else
                return SpiderAuthority.prototype.IsGameWon.call(this);
        };

        IDailySpiderAuthority.prototype.CurrentMoveState = function ()
        {
            if (this.MovesAllowed > 0 && !this.CardSupply.WaitingForAnimation)
            {
                if (this.TotalMoves > this.MovesAllowed + 1)
                    return MoveState.NoMovesLeft;
                if (this.TotalMoves == this.MovesAllowed + 1)
                {
                    return (this.IsGameWon() ? MoveState.CanMove : MoveState.NoMovesLeft);
                }
            }

            return SpiderAuthority.prototype.CurrentMoveState.call(this);
        };

//#if !CHEATS
        IDailySpiderAuthority.prototype.GetHint = function (cycle, cheat)
        {
            if(!cheat) {
                return new CardOp(this.CardSupply);
            } else {
                return SpiderAuthority.prototype.GetHint.call(this, cycle, cheat);
            }
        };
//#endif
        IDailySpiderAuthority.prototype.Deal = function ()
        {
            this.TotalMoves = 0;

            if (this.DeckSeeds.length > 0)
                this.CardSupply.DeckSeed = this.DeckSeeds[0];

            return SpiderAuthority.prototype.Deal.call(this);
        };

        IDailySpiderAuthority.prototype.SetDealScript = function (script)
        {
            this.DealScript = script;
        };

        IDailySpiderAuthority.prototype.SetNumBoardsCompleted = function (numBoards)
        {
        };

        return IDailySpiderAuthority;

});
